import { render, staticRenderFns } from "./PopupSelect895.vue?vue&type=template&id=07da2852&scoped=true"
import script from "./PopupSelect895.vue?vue&type=script&lang=js"
export * from "./PopupSelect895.vue?vue&type=script&lang=js"
import style1 from "./PopupSelect895.vue?vue&type=style&index=1&id=07da2852&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da2852",
  null
  
)

export default component.exports